import { useEffect, useState } from 'react';

import { useFetcher, useSearchParams } from '@remix-run/react';

import type { Post } from '~/interfaces/post';
import type { Publication } from '~/interfaces/publication';
import getContentTagIds from '~/utils/getContentTagIds';

const useFilterPosts = ({
  initialPosts,
  initialPagination,
  publication,
}: {
  initialPosts: any;
  initialPagination: any;
  publication: Publication;
}) => {
  const fetcher = useFetcher<{
    posts?: Post[];
  }>();
  const totalPages = initialPagination.total_pages;
  const [posts, setPosts] = useState(initialPosts);
  const [page, setPage] = useState(initialPagination.page);
  const fetchedData = fetcher?.data;

  const [searchParams] = useSearchParams();
  const q = searchParams.get('q');
  const contentTags = searchParams.getAll('content_tags');

  const fetchPosts = () => {
    const searchParams = new URLSearchParams();
    searchParams.append('page', String(page + 1));

    if (q) {
      searchParams.append('q', q);
    }

    for (const contentTagId of getContentTagIds(contentTags, publication.content_tags)) {
      searchParams.append('content_tags', contentTagId);
    }

    fetcher.load(`/posts?${searchParams.toString()}`);
  };

  useEffect(() => {
    if (posts) {
      setPage(1);
      setPosts(initialPosts);
    }
  }, [initialPosts]);

  useEffect(() => {
    if (fetchedData) {
      setPage(page + 1);
      setPosts(posts.concat(fetchedData?.posts));
    }
  }, [fetchedData]);

  return {
    postsToRender: posts,
    showLoadMore: page + 1 <= totalPages,
    isLoading: fetcher?.state !== 'idle',
    postsFetcher: fetcher,
    fetchPosts,
  };
};

export default useFilterPosts;
